import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Campaigner_ENFP_personality_header from '../../images/personality_types_details/diplomats_Campaigner_ENFP_personality_header.svg'
import diplomats_Campaigner_ENFP_romantic_relationships from '../../images/personality_types_details/diplomats_Campaigner_ENFP_romantic_relationships.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const enfp_relationships_dating = () => {
    return (
        <Layout>
            <main class="q-td analyst campaigner">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/compaigner-enfp-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses" className="tab with-progress ">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-relationships-dating" className="tab with-progress active">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-friends" className="tab with-progress ">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-careers" className="tab with-progress ">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfps-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header diplomat campaigner">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Campaigner_ENFP_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Campaigner</span> Personality</h1>
                        <div class="code">ENFP-A / ENFP-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>
                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/compaigner-enfp-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className="active"><Link to="/personality-types/compaigner-enfp-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfps-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Romantic Relationships</h1>


                        <p>When it comes to relationships, there’s hardly anyone around who is more excited than Campaigners to share with their partners the bounty of ideas and eye-opening experiences that life has to offer. For people with the Campaigner personality type, relationships are a joyous process of mutual exploration and imagination, a chance to connect with another soul. Campaigners take their relationships seriously, and are known for their uninhibited and unshakeable devotion to the people to whom they’ve committed their hearts.</p>

                        <div class="description-pullout">Campaigners have the advantage of irresistible charm when it comes to attracting a partner – Campaigners’ warmth, excitement and passion are simply alluring.</div>

                        <p>In the dating phase, if Campaigners can be said to tolerate such a formal process to begin with, they will show these qualities by showering their new flames with affection, and will do everything they can to build a strong relationship by demonstrating their devotion and reliability by whatever means available.</p>

                        <div class="scene">
                            <img alt="Campaigner romantic relationships" src={diplomats_Campaigner_ENFP_romantic_relationships} alt="Campaigner romantic relationships" />
                        </div>

                        <h2>You Cannot Live Without a Fire</h2>

                        <p>Long-distance relationships are quite common among Campaigners, as they view physical distance as just another idea, no match for concepts like love. This gives them the chance to demonstrate their commitment, both by staying true despite the physical separation, and with overtures of effort to surprise their partners, crossing that distance on a whim. These are demonstrations of Campaigners’ mystery, idealism and deep emotion, and such efforts often keep the flames of a relationship burning bright.</p>

                        <p>People with the Campaigner personality type express these ideals sexually as well, exploring the physical with imagination and passion, viewing these times together as a chance to let their feelings for each other shine, sharing their love and affection. Campaigners will willingly experiment with their partners, even early in a relationship, but they can also be oddly perfectionistic, believing that these physical acts are a representation of their deeper love, and as such should not be performed carelessly. This perfectionism is also a reflection of their sensitivity, their desire to not disappoint, and Campaigners appreciate a well-placed compliment.</p>

                        <p>Not everyone can handle the excitement, occasional neediness, and emotional ups and downs that this philosophy entails, whether long-distance or long-term, mystical or physical. Campaigners constantly explore new ideas and improvements, fantasize about future possibilities – in dating, this tendency to look at potential rather than the present can be self-defeating, and their spontaneity makes it harder to stay focused on their end goal of a long-term relationship. If their partners aren’t able to reciprocate these acts of excitement and devotion, Campaigners will likely end up feeling unhappy and misunderstood.</p>

                        <h2>So, You Think You Know the Real Me?</h2>

                        <p>Campaigners go all-in with their relationships, and if they fall apart despite their efforts, they can end up plagued with questions about why the relationship failed and what they could have done differently – without a buoy, these thoughts can crush Campaigners’ self-esteem as they sink into depression. It’s important for Campaigner personalities, as with anyone, to remember that relationships are in all ways mutual – mutual interest, mutual growth, and mutual responsibility – and they can’t be solely accountable.</p>

                        <p>After a trial like this, Campaigners may be reluctant to open up and commit, and it can take years for a partner to navigate their bewildering depth and intensity, falsely believing that Campaigners’ enthusiasm and apparent openness means that they wear everything on their sleeves. The reality is that Campaigners’ spontaneity, the seeming inconsistency and erraticism the untrained eye sees, isn’t a product of flightiness or lack of depth, but the opposite – it is a drive to express ideas about a mystical, all-encompassing energy, in the confines of a physical world, and underlying it all is the uniting principle of love, expressed in many different ways, but unshakeable and infinite at its core.</p>

                        <div class="number">03</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/compaigner-enfp-strengths-and-weaknesses' className='next-feature'>
                            Strengths and Weaknesses
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/compaigner-enfp-friends' className='next-feature'>
                            Friendships
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default enfp_relationships_dating
